export default __webpack_public_path__ + "static/media/info-bid-1.ba1e495b.jpg";